import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { KiAnfrage } from '../models/ki.model';

/** Gespeicherte KI-Anfrage für den Absprung aus dem Postfach (`?kiAnfrage`), ohne neue Anfrage zu starten. */
@Injectable({ providedIn: 'root' })
export class KiAnfrageService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiBaseUrl}/api/v1/projects`;

  laden(projectId: string, anfrageId: string): Observable<KiAnfrage> {
    return this.http.get<KiAnfrage>(
      `${this.base}/${encodeURIComponent(projectId)}/ki/anfragen/${encodeURIComponent(anfrageId)}`,
    );
  }
}
